<template>
    <layout-theme>
        <div class="container mt-5">
            <div class="column is-12 is-centered">
                <b-message type="is-success" has-icon>
                    Seja bem-vindo e aproveite seu tempo.<br />
                    Aguarde a inicialização do equipamento...
                </b-message>
            </div>
        </div>
    </layout-theme>
</template>

<script>
import { mapGetters } from 'vuex'
import LayoutTheme from '@/components/LayoutTheme.vue'

export default {
    components: {
        LayoutTheme,
    },

    mounted() {
        if (this.usage.remaining_use) {
            console.log(`Tempo restante: ${this.usage.remaining_use}s`)
            parent.postMessage({ type: 'remaining_time', value: `${this.usage.remaining_use}` }, '*')
        } else {
            this.$buefy.dialog.alert({
                message: this.$ml.get('Não foi possível obter o tempo restante da utilização.'),
                type: 'is-danger',
            })
        }
    },

    methods: {
    },

    computed: {
        ...mapGetters({
            usage: 'getUsage',
        })
    }
}
</script>